import React from 'react';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../../../framework/bar-button/BarButtonFw';
import { BasePage } from '../../../../../framework/pages/BasePage';
import FormFw from "../../../../../framework/form/FormFw";


export class ReplicarUnidadMedida extends BasePage {
    
    
    createPageProperties = (pageApi) => {
        return {
            title: 'Replicar Unidad de Medida',
        };
    }
    


    
    renderPage(pageApi) {        
        const getForm = () => pageApi.getComponent('formReplicarUM');
        const getGridParametros = () => pageApi.getParentApi().getComponent('parametrosGrid');
        
        const barHeaderConfig = {
            fields:[
                {...BUTTON_DEFAULT.SAVE, onClick: async () => {          
                    let umId = getForm().getData().um_id;
                    let umLabel = getForm().getFieldApi('um_id').getSelectedItem().label;
                    let filaInicio = getForm().getData().filaInicio;
                    let filaFin = getForm().getData().filaFin;
                    getGridParametros().getData().map( (gp) => {
                        if(gp.ROW_ORDER >= filaInicio && gp.ROW_ORDER <= filaFin){
                            getGridParametros().updateItem({
                                ...gp,
                                um_id: umId,
                                desUM: umLabel
                            });
                        }
                    });                    
                    await getGridParametros().saveItemEditing();
                    getGridParametros().refresh();                    
                    pageApi.hideThisModal();
                }},
                {...BUTTON_DEFAULT.RETURN, onClick: () => pageApi.hideThisModal()}
            ]
        }

        const formConfig = {
            layout: 'vertical',
            // ...getFormDefaultParams(),
            fields:[
                { type: 'select', name: 'um_id', label: 'Unidad Medida', labelName: 'um_des', search: true, editable: true, load: { queryId: 583, params: () => {
                    return {
                        id_metodo: pageApi.getParentApi().name.data.id_metodo
                    }
                } }, column: 4 },                
                { type: 'number', name: "filaInicio", label: "Fila Inicio", column: 3},
                { type: 'number', name: "filaFin", label: "Fila Fin", column: 3},
            ]
        }
    
        return (
            <>
                <FormFw
                    name="formReplicarUM"
                    getParentApi={pageApi.getApi}
                    config={formConfig}
                />
                <BarButtonFw 
                    name="agregarButton" 
                    getParentApi={pageApi.getApi}
                    config={barHeaderConfig}
                />
            </>
        )

    }
    
}
